module.exports = "/packs/onbording_03-e52ae76f1cbd01119a269bf9b9268719.jpg";